export const YOUTUBE_CHANNEL_VERIFICATION_CODE = "🎒🤩🎒";
